import { forwardRef, useImperativeHandle, useRef } from 'react';
import { StyleSheet, View } from 'react-native';
import Carousel from 'react-native-reanimated-carousel';

const CarouselSlide = forwardRef((props, ref) => {
  const carousel = useRef(null);

  useImperativeHandle(ref, () => ({
    prev(item) {
      carousel.current.prev({ ...item });
    },
    next(item) {
      carousel.current.next({ ...item });
    },
    getCurrentIndex() {
      return carousel.current.getCurrentIndex();
    },
    scrollTo(item) {
      carousel.current.scrollTo({ ...item });
    },
  }));

  return (
    <View dataSet={{ carousel: 'wrapper' }} style={styles.wrapper}>
      <Carousel
        ref={carousel}
        loop={props.loop}
        width={props.width}
        height={props.height}
        autoPlay={props.autoPlay}
        defaultIndex={0}
        data={props.data}
        scrollAnimationDuration={props.scrollAnimationDuration}
        onSnapToItem={props.onSnapToItem}
        renderItem={props.renderItem}
        {...props}
      />

      {props.children}
    </View>
  );
});

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    alignSelf: 'center',
    alignItems: 'center',
  },
});

export default CarouselSlide;
